import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/services/actions/auth.service";
import { UserService } from "src/app/services/user.service";
import { Router } from "@angular/router";

@Component({
	selector: "app-inicio",
	templateUrl: "./inicio.component.html",
	styleUrls: ["./inicio.component.scss"],
})
export class InicioComponent implements OnInit {
	loginForm = new FormGroup({
		userLogin: new FormControl(),
		password: new FormControl(),
	});

	constructor(
		private toastr: ToastrService,
		private authService: AuthService,
		private userService: UserService,
		private router: Router
	) {}

	ngOnInit() {}

	login() {
		let userValues = this.loginForm.getRawValue();

		const userLogin = userValues["userLogin"]

		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const isValidCpf = this.verifyCpf(userLogin)
		
		if (!re.test(String(userLogin).toLowerCase()) && !isValidCpf) {
			this.toastr.error("E-mail ou CPF inválido", "Erro");
			return;
		}

		if (userValues["password"].length < 8) {
			this.toastr.error(
				"A senha deve conter pelo menos 8 caracteres",
				"Erro"
			);
			return;
		}

		this.authService.login(userValues).subscribe(
			(res) => {
				if (res['mensagem'] && res['mensagem'] === 'Sua conta ainda não foi confirmada.') {
					this.toastr.warning(res['mensagem'], "Atenção")
						this.router.navigate([
							"cadastro/" +
							res['id'] +
								"/" +
								(res['filePerfil'] ? "1" : "0") +
								"/" +
								(res['fileDoc'] ? "1" : "0") +
								"/" +
								(res['fileCrp'] ? "1" : "0"),
						])
						return
				}
				this.userService.setUser(res["user"]);
				this.router.navigate(["logado"]);
			},
			(err) => {
				if (err.status == 401) {
					this.toastr.warning('E-mail / CPF ou senha incorretos.Usuário inválido.', "Atenção");
				} else {
					this.toastr.error('Erro interno, por favor contate o suporte.', "Erro");
				}
			}
		);
	}

	verifyCpf(cpf){
		cpf = cpf.replace(/\D/g, '');
		if(cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
		var result = true;
		[9,10].forEach(function(j){
			var soma = 0, r;
			cpf.split(/(?=)/).splice(0,j).forEach(function(e, i){
				soma += parseInt(e) * ((j+2)-(i+1));
			});
			r = soma % 11;
			r = (r <2)?0:11-r;
			if(r != cpf.substring(j, j+1)) result = false;
		});
		return result;
	}
}
